import { css, useTheme } from '@emotion/react'
import React from 'react'
import Link from './Link'
import config from '../../../config.json'
import { switchSocial } from '../page-builder/SocialLinks'

function Fab() {
    const theme = useTheme()
    const style = css`
        display: flex;
        flex-wrap: nowrap;
        position: fixed;
        bottom: 5.5rem;
        right: 2rem;
        background-color: ${theme.colors?.secondary};
        color: ${theme.colors?.primary};
        z-index: 99;
        border-radius: 3rem;
        gap: 0.5rem;
        justify-content: space-around;
        ${config.theme?.components?.fab?.css}
    `
    const innerStyle = css`
        display: inline-flex;
        padding: 0.5rem;
        flex: 1;
        min-width: fit-content;
        justify-content: center;

        a {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;
            font-size: 1.3rem;
        }
    `

    if (!config.texts?.fab) return null

    const items = (Array.isArray(config.texts?.fab)
        ? config.texts?.fab
        : [config.texts?.fab]).filter(i => Boolean(i.title))

    if (!items.length) return null

    return (
        <div css={style}>
            {items.map((i, idx) =>
                <Link key={idx} external={true} href={i.link} css={[innerStyle, i.css]}>
                    {Boolean(i.icon) && <span className="text-2xl">
                        {switchSocial(i.icon)}
                    </span>}
                    <span className="title">{i.title}</span>
                </Link>
            )}
        </div>
    )
}

export default Fab